import * as React from 'react';
import { createPortal } from 'react-dom';
function createWrapper(id) {
    const element = document.createElement('div');
    element.setAttribute('id', id);
    element.classList.add('hst-portal');
    document.body.appendChild(element);
    return element;
}
const Portal = ({ children, target }) => {
    const [wrapperElement, setWrapperElement] = React.useState(() => typeof target !== 'string' ? target : null);
    React.useLayoutEffect(() => {
        if (typeof target !== 'string') {
            return;
        }
        let element = document.getElementById(target);
        let created = false;
        if (!element) {
            created = true;
            element = createWrapper(target);
        }
        setWrapperElement(element);
        return () => {
            if (created && (element === null || element === void 0 ? void 0 : element.parentNode)) {
                element.parentNode.removeChild(element);
            }
        };
    }, [target]);
    if (!wrapperElement)
        return null;
    return createPortal(children, wrapperElement);
};
export default Portal;
